import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SentimentRoutingModule } from './sentiment-routing.module';
import { SentimentFilterComponent } from './components/scripts/sentimentFilter.component';
import { SentimentService } from './services/sentiment.service';
import { SentimentComponent } from './components/scripts/sentiment.component';
import { MatNativeDateModule, MatAutocompleteModule } from '@angular/material';
import { BOMaterialModule } from '../material-module';
import { PostService } from '../shared/services/post.service';
import { SentimentGroupService } from './services/sentimentgroup.service';
import { OwlDateTimeModule } from 'ng-pick-datetime';
import { OwlMomentDateTimeModule } from 'ng-pick-datetime-moment';
import { MomentModule } from 'angular2-moment';
import { SharedModule } from '../shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    OwlDateTimeModule,
    OwlMomentDateTimeModule,
    MomentModule,
    BOMaterialModule,
    SentimentRoutingModule,
    SharedModule,
    NgbModule.forRoot()
  ],
  declarations: [
      SentimentFilterComponent,
      SentimentComponent
  ],
  providers: [
    SentimentService,
    SentimentGroupService,
    PostService
  ]
})

export class SentimentModule { }



// WEBPACK FOOTER //
// ./src/app/sentiment/sentiment.module.ts